// Auto-generated catalog translations (fr). Base content: Portuguese. Review before editing by hand.
export default {
    experiences: {
      "north-tour-cocoa-route": {
        "name": "Tour Nord & Route du Cacao",
        "category": "Culture & Nature",
        "cats": ["Expériences", "Culture", "Nature"],
        "duration": "Journée complète",
        "location": "Nord de São Tomé",
        "meetingPoint": "Prise en charge à l'hébergement (São Tomé ville)",
        "groupSize": "Privé ou petit groupe",
        "overview": "Un voyage à travers l'héritage du cacao, les roças historiques, les communautés de pêcheurs, les plages et les paysages du nord de São Tomé.",
        "highlights": ["Roças historiques de cacao", "Communautés de pêcheurs", "Plages et points de vue du nord"],
        "included": ["Guide local", "Transport", "Assistance Eco Collection"],
        "notIncluded": ["Déjeuner (selon configuration)", "Dépenses personnelles"],
        "bring": ["Chaussures confortables", "Eau", "Crème solaire"],
      },
      "wild-south-pico-cao-grande": {
        "name": "Sud Sauvage & Pico Cão Grande",
        "category": "Nature & Découverte de l'île",
        "cats": ["Expériences", "Nature"],
        "duration": "Journée complète",
        "location": "Sud de São Tomé",
        "meetingPoint": "Prise en charge à l'hébergement",
        "groupSize": "Privé ou petit groupe",
        "overview": "Le sud sauvage de São Tomé : l'imposant Pico Cão Grande, la côte sud, les paysages tropicaux et les communautés vivant entre la forêt et la mer.",
        "highlights": ["Pico Cão Grande", "Côte sud sauvage", "Communautés locales"],
        "included": ["Guide local", "Transport"],
        "notIncluded": ["Déjeuner (selon configuration)"],
        "bring": ["Chaussures confortables", "Eau", "Crème solaire"],
      },
      "ilheu-santana-by-boat": {
        "name": "Ilhéu Santana en Bateau",
        "category": "Mer & Nature",
        "cats": ["Expériences", "Mer", "Nature"],
        "duration": "Demi-journée",
        "location": "Côte Est, São Tomé",
        "meetingPoint": "À convenir après confirmation",
        "groupSize": "Petit groupe",
        "overview": "Expérience maritime le long de la côte est de São Tomé jusqu'à l'Ilhéu Santana, avec des paysages volcaniques et des arrêts pour la baignade.",
        "highlights": ["Ilhéu Santana", "Côte volcanique", "Baignade dans des eaux cristallines"],
        "included": ["Bateau", "Guide local"],
        "notIncluded": ["Équipement de snorkeling (selon configuration)"],
        "bring": ["Maillot de bain", "Serviette", "Crème solaire"],
      },
      "discover-principe": {
        "name": "Découverte de Príncipe : Roças, Histoire & Praia Banana",
        "category": "Culture, Nature & Histoire",
        "cats": ["Expériences", "Culture", "Nature"],
        "duration": "± 09:00–17:00/18:00",
        "location": "Île de Príncipe",
        "meetingPoint": "Santo António",
        "groupSize": "Visite guidée, principalement en voiture",
        "overview": "L'essentiel de Príncipe en une journée : agriculture et patrimoine des roças, plages emblématiques, communautés et une initiative locale de transformation et de recyclage du verre.",
        "highlights": ["Roça Paciência et Roça Belo Monte", "Praia Banana", "Initiative locale de recyclage du verre"],
        "included": ["Guide", "Véhicule", "Carburant", "Déjeuner"],
        "notIncluded": ["Dépenses personnelles"],
        "bring": ["Chaussures confortables", "Eau", "Crème solaire"],
      },
      "principe-biosphere": {
        "name": "Biosphère de Príncipe : Sentiers, Cascades & Communautés",
        "category": "Randonnée, Nature & Communauté",
        "cats": ["Expériences", "Nature"],
        "duration": "Journée complète",
        "location": "Réserve de la Biosphère, Príncipe",
        "meetingPoint": "Santo António",
        "groupSize": "Petit groupe",
        "overview": "Forêt dense, cascades, piscines naturelles, plantes endémiques et médicinales, communautés locales, culture de la pêche et production artisanale de savon.",
        "highlights": ["Cascade Ôquê Pipi", "Piscines naturelles", "Communautés et culture de la pêche"],
        "included": ["Guide", "Véhicule", "Carburant", "Déjeuner", "Taxe du parc naturel, le cas échéant"],
        "notIncluded": ["Dépenses personnelles"],
        "bring": ["Chaussures de randonnée", "Eau", "Répulsif anti-moustiques"],
      },
      "principe-by-sea": {
        "name": "Príncipe par la Mer : Côte, Grottes & Vie Marine",
        "category": "Mer & Nature",
        "cats": ["Expériences", "Mer", "Nature"],
        "duration": "± 09:00–15:00/16:00",
        "location": "Côte de Príncipe",
        "meetingPoint": "Baie de Santo António",
        "groupSize": "Petit groupe",
        "overview": "Excursion en bateau le long de la côte de Príncipe : formations rocheuses, grottes, baignade, snorkeling possible, communautés de pêcheurs et déjeuner en bord de mer, avec retour à la baie de Santo António. L'observation de tortues, dauphins, baleines et poissons est possible selon la saison et les conditions naturelles — observations non garanties.",
        "highlights": ["Grottes et formations rocheuses", "Snorkeling possible", "Déjeuner en bord de mer"],
        "included": ["Bateau", "Guide local", "Déjeuner en bord de mer"],
        "notIncluded": ["Équipement de snorkeling (selon configuration)"],
        "bring": ["Maillot de bain", "Serviette", "Crème solaire"],
      },
      "santiago-grand-island-tour": {
        "name": "Grand Tour de l'Île de Santiago",
        "category": "Découverte de l'île",
        "cats": ["Expériences", "Culture", "Nature"],
        "duration": "8h",
        "location": "Île de Santiago",
        "meetingPoint": "Prise en charge à l'hôtel vers 08:45",
        "groupSize": "Privé ou petit groupe",
        "overview": "Le nord et le sud de Santiago en une journée complète : l'île la plus africaine du Cap-Vert, entre montagnes, vallées, histoire et culture créole.",
        "highlights": ["Nord et sud de l'île", "Paysages de montagne", "Culture créole"],
        "included": ["Transport privé", "Déjeuner", "1 bouteille d'eau par personne"],
        "notIncluded": ["Dépenses personnelles"],
        "bring": ["Chaussures confortables", "Crème solaire"],
      },
      "authentic-northern-santiago": {
        "name": "Nord Authentique de Santiago",
        "category": "Culture & Vie locale",
        "cats": ["Expériences", "Culture"],
        "duration": "± 09:00–14:00",
        "location": "Nord de Santiago",
        "meetingPoint": "Prise en charge à l'hébergement",
        "groupSize": "Petit groupe",
        "overview": "La vie locale du nord de Santiago : la vallée de Principal, la communauté des Rabelados à Espinho Branco, les plantations de bananes de Santa Cruz, le marché municipal d'Assomada et un arrêt photo au point de vue de la Serra Malagueta.",
        "highlights": ["Communauté Rabelados", "Marché d'Assomada", "Plantations de bananes"],
        "included": ["Transport", "Déjeuner", "Eau"],
        "notIncluded": ["Dépenses personnelles"],
        "bring": ["Chaussures confortables", "Appareil photo"],
      },
      "traditional-fishing-beach-bbq": {
        "name": "Pêche Traditionnelle & Barbecue Privé sur la Plage",
        "category": "Mer, Pêche & Gastronomie",
        "cats": ["Expériences", "Mer", "Gastronomie"],
        "duration": "Demi-journée / Journée complète",
        "location": "Tarrafal, Santiago",
        "meetingPoint": "À convenir après confirmation",
        "groupSize": "Privé",
        "overview": "Bateau traditionnel, pêche artisanale, baignade en mer et préparation du poisson pêché lors d'un barbecue/déjeuner sur une plage. Possibilité de transport Praia ↔ Tarrafal selon l'option choisie.",
        "highlights": ["Pêche artisanale", "Barbecue sur la plage", "Bateau traditionnel"],
        "included": ["Bateau traditionnel", "Déjeuner/Barbecue", "Guide local"],
        "notIncluded": ["Transport Praia ↔ Tarrafal (selon option)"],
        "bring": ["Maillot de bain", "Serviette", "Crème solaire"],
      },
      "tarrafal-boat-swimming": {
        "name": "Bateau Traditionnel de Tarrafal & Baignade",
        "category": "Mer",
        "cats": ["Expériences", "Mer"],
        "duration": "Demi-journée",
        "location": "Tarrafal, Santiago",
        "meetingPoint": "Baie de Tarrafal",
        "groupSize": "Petit groupe",
        "overview": "Promenade en bateau traditionnel le long de la côte de Tarrafal avec possibilité de se baigner dans les eaux calmes de la baie.",
        "highlights": ["Côte de Tarrafal", "Baignade en mer", "Bateau traditionnel"],
        "included": ["Bateau traditionnel", "Guide local"],
        "notIncluded": ["Transport jusqu'à Tarrafal"],
        "bring": ["Maillot de bain", "Serviette"],
      },
      "cachupa-cooking": {
        "name": "Expérience Culinaire Capverdienne : Cachupa",
        "category": "Gastronomie & Culture",
        "cats": ["Expériences", "Gastronomie", "Culture"],
        "duration": "Demi-journée",
        "location": "Santiago",
        "meetingPoint": "À convenir après confirmation",
        "groupSize": "Petit groupe",
        "overview": "Expérience pratique de la préparation de la cachupa, le plat national capverdien, suivie d'une dégustation dans une ambiance locale.",
        "highlights": ["Préparation de la cachupa", "Dégustation", "Culture locale"],
        "included": ["Ingrédients", "Dégustation", "Hôte local"],
        "notIncluded": ["Transport (selon configuration)"],
        "bring": ["De l'appétit"],
      },
      "serra-malagueta-vale-principal-trek": {
        "name": "Trek Serra Malagueta → Vallée de Principal",
        "category": "Randonnée & Nature",
        "cats": ["Expériences", "Nature"],
        "duration": "± 2h45",
        "location": "Serra Malagueta, Santiago",
        "meetingPoint": "À convenir après confirmation",
        "groupSize": "Petit groupe",
        "overview": "Trekking de la Serra Malagueta à la vallée de Principal, entre vallées verdoyantes et villages de montagne.",
        "highlights": ["Serra Malagueta", "Vallée de Principal", "Villages de montagne"],
        "included": ["Transport", "Guide", "Déjeuner", "Frais d'entrée"],
        "notIncluded": ["Dépenses personnelles"],
        "bring": ["Chaussures de randonnée", "Eau", "Chapeau", "Crème solaire", "Lunettes de soleil"],
      },
      "serra-malagueta-mato-brasil-trek": {
        "name": "Trek Serra Malagueta → Mato Brasil",
        "category": "Randonnée & Nature",
        "cats": ["Expériences", "Nature"],
        "duration": "± 3h",
        "location": "Serra Malagueta, Santiago",
        "meetingPoint": "À convenir après confirmation",
        "groupSize": "Petit groupe",
        "overview": "Trekking plus exigeant de la Serra Malagueta à Mato Brasil. Recommandé pour les personnes physiquement actives ou ayant une expérience de la montagne.",
        "highlights": ["Sentier exigeant", "Paysages de montagne", "Nature endémique"],
        "included": ["Transport", "Guide", "Pique-nique"],
        "notIncluded": ["Dépenses personnelles"],
        "bring": ["Chaussures de randonnée", "Eau", "Chapeau", "Crème solaire"],
      },
      "pico-de-antonia-challenge": {
        "name": "Défi du Pico de Antónia",
        "category": "Randonnée & Défi",
        "cats": ["Expériences", "Nature"],
        "duration": "± 4–5h",
        "location": "Pico de Antónia, Santiago",
        "meetingPoint": "À convenir après confirmation",
        "groupSize": "Petit groupe",
        "overview": "Trekking vers le point culminant de l'île de Santiago. Recommandé pour les personnes en bonne condition physique et ayant une expérience de la randonnée en montagne.",
        "highlights": ["Point culminant de Santiago", "Défi de montagne", "Vues panoramiques"],
        "included": ["Transport privé", "Guide", "Pique-nique, selon la configuration choisie"],
        "notIncluded": ["Dépenses personnelles"],
        "bring": ["Chaussures de randonnée", "Eau", "Chapeau", "Crème solaire", "Vêtement chaud"],
      },
      "santiago-community-ecotourism": {
        "name": "Écotourisme Communautaire à Santiago",
        "category": "Communauté & Écotourisme",
        "cats": ["Expériences", "Culture", "Nature"],
        "duration": "Demi-journée / Journée complète",
        "location": "Intérieur de Santiago",
        "meetingPoint": "À convenir après confirmation",
        "groupSize": "Petit groupe",
        "overview": "Randonnées et contact avec les communautés locales, incluant la possibilité de visites dans des maisons locales, d'interactions et de découverte de la gastronomie traditionnelle. Les détails finaux dépendent de la configuration et du partenaire.",
        "highlights": ["Communautés locales", "Gastronomie traditionnelle", "Écotourisme"],
        "included": ["Guide local", "Selon la configuration"],
        "notIncluded": ["Selon la configuration"],
        "bring": ["Chaussures confortables", "Eau"],
      },
    },
    packages: {
      "sao-tome-discovery": {
        "name": "Découverte de São Tomé",
        "duration": "3 jours",
        "style": "Court séjour",
        "idealFor": "Première visite à São Tomé",
        "overview": "Une introduction parfaite à l'île : arrivée avec transfert, l'emblématique Route du Cacao et temps libre avant le départ.",
        "highlights": ["Tour Nord & Route du Cacao", "Transfert aéroport inclus", "Assistance locale Eco Collection"],
        "itinerary": [
          { "day": "Jour 1", "text": "Arrivée à São Tomé + transfert depuis l'aéroport + check-in" },
          { "day": "Jour 2", "text": "Tour Nord & Route du Cacao" },
          { "day": "Jour 3", "text": "Matinée libre + transfert de départ" },
        ],
        "accommodationNote": "Hébergement local sélectionné, selon vos préférences",
        "experiencesIncluded": ["Tour Nord & Route du Cacao"],
        "transfersNote": "Transferts aéroport inclus",
        "meals": "Selon l'hébergement choisi",
        "included": ["Hébergement", "Transfert aéroport", "Expérience Tour Nord & Route du Cacao", "Assistance locale"],
        "notIncluded": ["Vols", "Repas non mentionnés", "Dépenses personnelles"],
        "optional": ["Ilhéu Santana en Bateau", "Sud Sauvage & Pico Cão Grande"],
        "important": ["Prix final sur demande, selon la saison et les préférences"],
      },
      "sao-tome-explorer": {
        "name": "Exploration de São Tomé",
        "duration": "5 jours",
        "style": "Exploration de l'île",
        "idealFor": "Pour ceux qui veulent voir l'essentiel de l'île",
        "overview": "Cinq jours pour explorer São Tomé du nord au sud, avec la mer, le cacao et le sauvage Pico Cão Grande.",
        "highlights": ["Nord et sud de l'île", "Ilhéu Santana", "Pico Cão Grande"],
        "itinerary": [
          { "day": "Jour 1", "text": "Arrivée & accueil" },
          { "day": "Jour 2", "text": "Tour Nord & Route du Cacao" },
          { "day": "Jour 3", "text": "Sud Sauvage & Pico Cão Grande" },
          { "day": "Jour 4", "text": "Ilhéu Santana / expérience sélectionnée" },
          { "day": "Jour 5", "text": "Départ" },
        ],
        "accommodationNote": "Hébergement local sélectionné",
        "experiencesIncluded": ["Tour Nord & Route du Cacao", "Sud Sauvage & Pico Cão Grande", "Ilhéu Santana en Bateau"],
        "transfersNote": "Transferts aéroport inclus",
        "meals": "Selon l'hébergement choisi",
        "included": ["Hébergement", "Transferts", "Expériences mentionnées", "Assistance locale"],
        "notIncluded": ["Vols", "Repas non mentionnés"],
        "optional": ["Expérience de gastronomie locale"],
        "important": ["Prix final sur demande"],
      },
      "sao-tome-complete": {
        "name": "São Tomé Complet",
        "duration": "8 jours",
        "style": "Tour complet de l'île",
        "idealFor": "L'expérience la plus complète de São Tomé",
        "overview": "L'expérience la plus complète de l'île, combinant le nord, le sud, la mer, la culture, la nature et du temps libre.",
        "highlights": ["Nord, sud et mer", "Culture et gastronomie", "Temps libre pour les plages"],
        "itinerary": [
          { "day": "Jour 1", "text": "Arrivée et acclimatation" },
          { "day": "Jour 2", "text": "Tour Nord & Route du Cacao" },
          { "day": "Jour 3", "text": "Sud Sauvage & Pico Cão Grande" },
          { "day": "Jour 4", "text": "Ilhéu Santana en Bateau" },
          { "day": "Jour 5", "text": "Nature / cascade" },
          { "day": "Jour 6", "text": "Culture locale & gastronomie" },
          { "day": "Jour 7", "text": "Journée libre" },
          { "day": "Jour 8", "text": "Départ" },
        ],
        "accommodationNote": "Hébergement local sélectionné",
        "experiencesIncluded": ["Tour Nord & Route du Cacao", "Sud Sauvage & Pico Cão Grande", "Ilhéu Santana en Bateau", "Expérience nature/cascade", "Culture locale & gastronomie"],
        "transfersNote": "Transferts inclus",
        "meals": "Selon l'hébergement choisi",
        "included": ["Hébergement", "Transferts", "Expériences mentionnées", "Assistance locale"],
        "notIncluded": ["Vols", "Repas non mentionnés"],
        "optional": ["Surclassements d'hébergement"],
        "important": ["Prix final sur demande"],
      },
      "principe-essential": {
        "name": "L'Essentiel de Príncipe",
        "duration": "3 jours",
        "style": "Court séjour",
        "idealFor": "Un aperçu de Príncipe",
        "overview": "L'essentiel de l'île de Príncipe en trois jours : Santo António et l'excursion emblématique des roças jusqu'à Praia Banana.",
        "highlights": ["Excursion Découverte de Príncipe", "Praia Banana", "Santo António"],
        "itinerary": [
          { "day": "Jour 1", "text": "Arrivée + Santo António" },
          { "day": "Jour 2", "text": "Découverte de Príncipe : Roças, Histoire & Praia Banana" },
          { "day": "Jour 3", "text": "Départ" },
        ],
        "accommodationNote": "Hébergement local sélectionné",
        "experiencesIncluded": ["Découverte de Príncipe : Roças, Histoire & Praia Banana"],
        "transfersNote": "Transferts locaux inclus",
        "meals": "Déjeuner inclus dans l'excursion",
        "included": ["Hébergement", "Transferts locaux", "Découverte de Príncipe", "Assistance locale"],
        "notIncluded": ["Vols / liaison São Tomé ↔ Príncipe", "Repas non mentionnés"],
        "optional": ["Príncipe par la Mer"],
        "important": ["Prix final sur demande"],
      },
      "discover-principe-package": {
        "name": "Découverte de Príncipe",
        "duration": "5 jours",
        "style": "Île Signature",
        "idealFor": "Trois expériences signatures. Un voyage sur l'île.",
        "overview": "Trois expériences signatures. Un voyage à travers l'île : roças et histoire, biosphère et sentiers, et Príncipe vu de la mer.",
        "highlights": ["Roças & Praia Banana", "Biosphère & Sentiers", "Príncipe par la Mer"],
        "itinerary": [
          { "day": "Jour 1", "text": "Arrivée + hébergement" },
          { "day": "Jour 2", "text": "Roças, Histoire & Praia Banana" },
          { "day": "Jour 3", "text": "Biosphère, Sentiers, Cascades & Communautés" },
          { "day": "Jour 4", "text": "Príncipe par la Mer" },
          { "day": "Jour 5", "text": "Matinée libre + départ" },
        ],
        "accommodationNote": "Hébergement local sélectionné",
        "experiencesIncluded": ["Découverte de Príncipe", "Biosphère de Príncipe", "Príncipe par la Mer"],
        "transfersNote": "Transferts locaux inclus",
        "meals": "Déjeuners inclus dans les expériences",
        "included": ["Hébergement", "Transferts locaux", "Trois expériences de signature", "Assistance locale"],
        "notIncluded": ["Vols / liaison São Tomé ↔ Príncipe"],
        "optional": ["Journée supplémentaire à la plage"],
        "important": ["Prix final sur demande"],
      },
      "stp-signature": {
        "name": "Signature São Tomé & Príncipe",
        "duration": "8 jours",
        "style": "Deux îles",
        "idealFor": "Les deux îles en un seul voyage",
        "overview": "Le meilleur des deux îles : le cacao et le sud sauvage de São Tomé, et le trio signature de Príncipe.",
        "highlights": ["Deux îles", "Cacao + Biosphère + Mer", "Assistance locale continue"],
        "itinerary": [
          { "day": "Jour 1", "text": "Arrivée à São Tomé" },
          { "day": "Jour 2", "text": "Nord & Cacao" },
          { "day": "Jour 3", "text": "Sud Sauvage" },
          { "day": "Jour 4", "text": "Transfert / vol pour Príncipe" },
          { "day": "Jour 5", "text": "Roças & Praia Banana" },
          { "day": "Jour 6", "text": "Biosphère & Sentiers" },
          { "day": "Jour 7", "text": "Príncipe par la Mer / temps libre" },
          { "day": "Jour 8", "text": "Départ" },
        ],
        "accommodationNote": "Hébergements locaux sur les deux îles",
        "experiencesIncluded": ["Tour Nord & Route du Cacao", "Sud Sauvage & Pico Cão Grande", "Découverte de Príncipe", "Biosphère de Príncipe", "Príncipe par la Mer"],
        "transfersNote": "Transferts et liaison inter-îles coordonnés par Eco Collection",
        "meals": "Selon le programme",
        "included": ["Hébergements", "Transferts", "Expériences mentionnées", "Assistance locale"],
        "notIncluded": ["Vols internationaux"],
        "optional": ["Surclassements d'hébergement"],
        "important": ["Prix final sur demande"],
      },
      "stp-grand-journey": {
        "name": "Grand Voyage STP",
        "duration": "10 jours",
        "style": "Premium & Personnalisable",
        "idealFor": "Voyage premium sur mesure",
        "overview": "Le produit premium d'Eco Collection : hébergement, transferts, multiples expériences, temps libre, assistance locale et surclassements optionnels — entièrement personnalisable.",
        "highlights": ["Entièrement personnalisable", "Premium", "Surclassements optionnels"],
        "itinerary": [
          { "day": "Jours 1–4", "text": "São Tomé : nord, sud, mer et culture" },
          { "day": "Jour 5", "text": "Liaison vers Príncipe" },
          { "day": "Jours 6–9", "text": "Príncipe : roças, biosphère, mer et temps libre" },
          { "day": "Jour 10", "text": "Départ" },
        ],
        "accommodationNote": "Hébergements sélectionnés avec vous",
        "experiencesIncluded": ["Programme sur mesure"],
        "transfersNote": "Tous les transferts coordonnés",
        "meals": "Selon le programme",
        "included": ["Hébergements", "Transferts", "Expériences combinées", "Assistance locale dédiée"],
        "notIncluded": ["Vols internationaux"],
        "optional": ["Surclassements", "Expériences supplémentaires", "Nuits additionnelles"],
        "important": ["Proposition personnalisée sur demande"],
      },
      "santiago-essential": {
        "name": "L'Essentiel de Santiago",
        "duration": "3 jours",
        "style": "Court séjour",
        "idealFor": "Plage + culture + introduction à l'île",
        "overview": "Plage, culture et une introduction à l'île de Santiago en trois jours.",
        "highlights": ["Cidade Velha", "Plage", "Culture créole"],
        "itinerary": [
          { "day": "Jour 1", "text": "Arrivée / transfert" },
          { "day": "Jour 2", "text": "Cidade Velha / région Sud + expérience locale" },
          { "day": "Jour 3", "text": "Départ" },
        ],
        "accommodationNote": "Hébergement local sélectionné",
        "experiencesIncluded": ["Expérience locale au choix"],
        "transfersNote": "Transfert d'arrivée inclus",
        "meals": "Selon l'hébergement",
        "included": ["Hébergement", "Transfert d'arrivée", "Expérience locale", "Assistance locale"],
        "notIncluded": ["Vols"],
        "optional": ["Expérience Culinaire Capverdienne : Cachupa"],
        "important": ["Prix final sur demande"],
      },
      "santiago-explorer": {
        "name": "Exploration de Santiago",
        "duration": "5 jours",
        "style": "Exploration de l'île",
        "idealFor": "Santiago complet : plage, intérieur et nord",
        "overview": "Plage, Cidade Velha, intérieur de l'île, nord de Santiago, Serra Malagueta / Tarrafal et culture locale en cinq jours.",
        "highlights": ["Cidade Velha", "Intérieur + Nord", "Serra Malagueta / Tarrafal"],
        "itinerary": [
          { "day": "Jour 1", "text": "Arrivée" },
          { "day": "Jour 2", "text": "Cidade Velha & région Sud" },
          { "day": "Jour 3", "text": "Intérieur de l'île" },
          { "day": "Jour 4", "text": "Nord de Santiago / Serra Malagueta / Tarrafal" },
          { "day": "Jour 5", "text": "Culture locale + départ" },
        ],
        "accommodationNote": "Hébergement local sélectionné",
        "experiencesIncluded": ["Grand Tour de l'Île de Santiago", "Nord Authentique de Santiago"],
        "transfersNote": "Transferts inclus",
        "meals": "Selon le programme",
        "included": ["Hébergement", "Transferts", "Expériences mentionnées", "Assistance locale"],
        "notIncluded": ["Vols"],
        "optional": ["Pêche Traditionnelle & Barbecue Privé sur la Plage"],
        "important": ["Prix final sur demande"],
      },
      "santiago-active-local": {
        "name": "Santiago Actif & Local",
        "duration": "7 jours",
        "style": "Actif & Local",
        "idealFor": "Voyageurs actifs qui veulent vivre l'île",
        "overview": "Une semaine active et locale à Santiago : île complète, trekking, mer, pêche traditionnelle et gastronomie.",
        "highlights": ["Grand Tour de l'Île de Santiago", "Trek Serra Malagueta", "Pêche & BBQ + Cachupa"],
        "itinerary": [
          { "day": "Jour 1", "text": "Arrivée" },
          { "day": "Jour 2", "text": "Grand Tour de l'Île de Santiago" },
          { "day": "Jour 3", "text": "Trek Serra Malagueta → Vallée de Principal" },
          { "day": "Jour 4", "text": "Libre / Plage" },
          { "day": "Jour 5", "text": "Pêche Traditionnelle & Barbecue Privé sur la Plage" },
          { "day": "Jour 6", "text": "Expérience Culinaire Capverdienne : Cachupa & Culture Locale" },
          { "day": "Jour 7", "text": "Départ" },
        ],
        "accommodationNote": "Hébergement local sélectionné",
        "experiencesIncluded": ["Grand Tour de l'Île de Santiago", "Trek Serra Malagueta → Vallée de Principal", "Pêche Traditionnelle & Barbecue Privé sur la Plage", "Expérience Culinaire Capverdienne : Cachupa"],
        "transfersNote": "Transferts inclus",
        "meals": "Selon le programme (déjeuners lors des expériences)",
        "included": ["Hébergement", "Transferts", "Expériences mentionnées", "Assistance locale"],
        "notIncluded": ["Vols"],
        "optional": ["Défi du Pico de Antónia"],
        "important": ["Prix final sur demande"],
      },
    },
    transfers: {
      "praia-tarrafal": {
        "capacities": ["1–3 passagers", "4–14 passagers"],
        "name": "Praia Airport / Praia → Tarrafal",
        "distance": "74 km",
        "time": "± 1h30",
        "vehicle": "Transfert privé",
        "note": "Prix final sur demande, selon le véhicule et le nombre de passagers.",
        "points": [
          { "name": "Praia", "lat": 14.917, "lng": -23.509 },
          { "name": "Tarrafal", "lat": 15.276, "lng": -23.752 },
        ],
      },
    },
    destinations: {
      "sao-tome-principe": {
        "positioning": "Cacao, forêt tropicale et plages immaculées.",
        "categories": ["Culture & Nature", "Mer", "Randonnée", "Hébergement", "Transferts", "Forfaits complets"],
        "subs": {
          "sao-tome": { "tagline": "Là où la forêt rencontre l'océan.", "cta": "Explorer São Tomé", "desc": "L'île principale de l'archipel : les forêts tropicales du parc naturel d'Obô, les roças de cacao centenaires, les plages désertes et une culture créole vibrante. Chaque expérience est animée par des professionnels locaux de notre réseau." , "tags": "Nature · Culture · Cacao"},
          "principe": { "tagline": "La nature à l'état pur.", "cta": "Découvrir Príncipe", "desc": "Réserve mondiale de la biosphère de l'UNESCO : forêt primaire intacte, cascades cachées, roças historiques et certaines des plus belles plages d'Afrique, comme l'emblématique Praia Banana." , "tags": "Biosphère · Plages · Roças"},
        },
      },
      "cabo-verde": {
        "positioning": "Là où la montagne rencontre la mer.",
        "categories": ["Randonnée", "Culture", "Mer", "Gastronomie", "Hébergement", "Transferts", "Forfaits complets"],
        "subs": {
          "santiago": { "tagline": "Là où la montagne rencontre la mer.", "cta": "Explorer Santiago", "desc": "Sur l'île de Santiago, là où la montagne rencontre la mer : sentiers volcaniques dans la Serra Malagueta, Cidade Velha, classée au patrimoine de l'UNESCO, pêche artisanale et l'âme créole de la musique capverdienne." , "tags": "Montagnes · Océan · Culture"},
        },
      },
      "ghana": {
        "cta": "Découvrir le Ghana",
        "positioning": "Culture, patrimoine et tourisme communautaire.",
        "categories": ["Culture & Patrimoine", "Expériences locales", "Nature", "Tourisme communautaire", "Hébergement", "Transferts", "Forfaits complets"],
        "subs": {
        },
      },
      "kenya": {
        "cta": "Planifier le Kenya",
        "positioning": "Safari, faune et côte.",
        "categories": ["Safari", "Faune", "Culture", "Nature", "Côte", "Expériences communautaires", "Hébergement", "Transferts", "Forfaits complets"],
        "subs": {
        },
      },
      "tanzania": {
        "cta": "Planifier la Tanzanie",
        "positioning": "Des paysages extraordinaires aux communautés locales et à l'océan Indien.",
        "categories": ["Safari", "Faune", "Nature", "Culture", "Communautés locales", "Zanzibar / Côte", "Hébergement", "Transferts", "Forfaits complets"],
        "subs": {
        },
      },
      "mauritius": {
        "cta": "Explorer Maurice",
        "positioning": "Découvrez l'île Maurice à travers les personnes qui la connaissent le mieux.",
        "categories": ["Expériences insulaires", "Plages", "Nature", "Culture", "Gastronomie", "Expériences en bateau", "Hébergement", "Transferts", "Forfaits complets"],
        "subs": {
        },
      },
      "maldives": {
        "cta": "Explorer les Maldives",
        "positioning": "Découvrez les Maldives au-delà de la carte postale.",
        "categories": ["Séjours sur l'île", "Îles locales", "Complexes hôteliers", "Expériences marines", "Plongée / Snorkeling", "Expériences en bateau", "Transferts", "Forfaits complets"],
        "subs": {
        },
      },
    },
};
